import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import AuthContext from '../auth/index';
import { LayoutPrincipal } from '../layout/principal';

import Forbidden from '../pages/forbidden/forbidden';
import Dashboard from '../pages/dashboard/dashboard';
import Home from '../pages/home';
import Cards from '../pages/cards';
import Novidades from '../pages/novidades/novidades';
import Eventos from '../pages/eventos';
import Developers from '../pages/developers';
import Perguntas from '../pages/perguntas/perguntas';
import Carrossel from '../pages/carrosseis/carrosseis';
import Diagnosticos from '../pages/diagnosticos/diagnosticos';
import Sugestoes from '../pages/sugestoes';
import GestaoPerfil from '../pages/gestaoPerfil/gestaoPerfil';
import Servicos from '../pages/dashboardServicos/dashboardServicos';
import Funcionalidades from '../pages/funcionalidades/funcionalidades';
import Pushs from '../pages/pushs/pushs';
import Cupons from '../pages/cupons/cupons';
import Gameficacao from '../pages/gameficacao/gameficacao';
import GestaoUsuario from '../pages/gestaoUsuarios';
import TabelasDeControle from '../pages/tabelasDeControle';
import { EditarVersaoApp } from '../pages/tabelasDeControle/components/VersaoApp/EditarVersaoApp';
import { EditarTipoRegistro } from '../pages/tabelasDeControle/components/TipoRegistro/EditarTipoRegistro';
import { CopiarTipoRegistro } from '../pages/tabelasDeControle/components/TipoRegistro/CopiarTipoRegistro';
import { EditarProjetoAcoes } from '../pages/tabelasDeControle/components/ProjetosAcoes/EditarProjetoAcoes';
import NewReports from '../pages/reports';
import { EditarPerfilUsuario } from '../pages/reports/components/PerfilUsuarios/EditarPerfilUsuario';
import { EditarListaUsuario } from '../pages/reports/components/PerfilUsuarios/EditarListaUsuario';
import { EditarCanaisDigitais } from '../pages/tabelasDeControle/components/CanaisDigitais/EditarCanaisDigitais';
import { BaSeErrorPage } from "@base/react";
import { useApp } from "../context/app";
import { hasAdminRole, hasGestorSSERole } from "../utils/hasPermission";
import { EditarEventoSebrae } from '../pages/tabelasDeControle/components/EventoSebrae/EditarEventoSebrae';

const PrivateRoute = ({
  component: Component,
  layout: Layout,
  roles = [],
  isPublicAccess = false,
  inMaintenance = false,
  allowAccessGestorSSE = false,
  ...rest
}) => {
  const { authenticated } = useContext(AuthContext);

  const [permission, setPermission] = useState(null);

  const { maintenanceMode } = useApp();


    useEffect(() => {

        const loadPermissions = async () => {
            try {
                const isAdmin = await hasAdminRole()
                const isGestorSSE = await hasGestorSSERole()
                if (!authenticated) {
                    setPermission(false);
                } else {
                    const hasPermission = isAdmin || (allowAccessGestorSSE && isGestorSSE);
                    setPermission(hasPermission);
                }
            } catch (error) {
                console.error("Error fetching permission:", error);
                setPermission(false);
            }
        };
        authenticated && loadPermissions();
    }, [authenticated, allowAccessGestorSSE]);

    if (!!inMaintenance && !!maintenanceMode) {
        return (
            <Route
                {...rest}
                render={() => (
                    <Layout>
                        <BaSeErrorPage
                            error="Desculpe pelo transtorno, voltamos em breve."
                            title="Estamos em manutenção"
                        />
                    </Layout>
                )}
            />
        );
    }

  if (permission === null && !isPublicAccess) {
    return null;
  }

  if ((authenticated && isPublicAccess) || permission) {
    return (
      <Route
        {...rest}
        render={(props) => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
      />
    );
  } else {
    return (
      <Route
        {...rest}
        render={(props) => (
          <Redirect
            to={{
              pathname: '/forbidden',
              state: { redirectTo: props.location },
            }}
          />
        )}
      />
    );
  }
};

const PublicRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <AuthContext.Consumer>
    {({ keycloak }) => {
      return (
        <Route
          {...rest}
          render={(props) =>
            Layout ? (
              <Layout>
                <Component {...props} authenticated={keycloak.authenticated} />
              </Layout>
            ) : (
              <Component {...props} authenticated={keycloak.authenticated} />
            )
          }
        />
      );
    }}
  </AuthContext.Consumer>
);

const Routes = () => {


    return (
        <BrowserRouter>
            <Switch>
                <PublicRoute exact path="/" layout={LayoutPrincipal} component={Home}/>
                <PublicRoute exact path="/developers" component={Developers}/>
                <PublicRoute
                    exact
                    path="/forbidden"
                    layout={LayoutPrincipal}
                    component={Forbidden}
                />

                <PrivateRoute
                    path="/dashboard"
                    layout={LayoutPrincipal}
                    component={Dashboard}
                    isPublicAccess={true}
                    allowAccessGestorSSE={true}
                    inMaintenance={true}
                />
                <PrivateRoute path="/pushs" layout={LayoutPrincipal} component={Pushs}/>
                <PrivateRoute
                    path="/cupons"
                    layout={LayoutPrincipal}
                    component={Cupons}
                />
                <PrivateRoute
                    path="/gameficacao"
                    layout={LayoutPrincipal}
                    component={Gameficacao}
                />
                <PrivateRoute path="/cards" layout={LayoutPrincipal} component={Cards}/>
                <PrivateRoute
                    path="/novidades"
                    layout={LayoutPrincipal}
                    component={Novidades}
                />
                <PrivateRoute
                    path="/eventos"
                    layout={LayoutPrincipal}
                    component={Eventos}
                />
                <PrivateRoute
                    path="/faqs"
                    layout={LayoutPrincipal}
                    component={Perguntas}
                />
                <PrivateRoute
                    path="/carrossel"
                    layout={LayoutPrincipal}
                    component={Carrossel}
                />
                <PrivateRoute
                    path="/diagnosticos"
                    layout={LayoutPrincipal}
                    component={Diagnosticos}
                />
                <PrivateRoute
                    path="/gestao-usuarios"
                    layout={LayoutPrincipal}
                    component={GestaoUsuario}
                />

                <PrivateRoute
                    path="/reports/perfil/:id/edit"
                    layout={LayoutPrincipal}
                    component={EditarPerfilUsuario}
                    isPublicAccess={true}
                    allowAccessGestorSSE={true}
                />
                <PrivateRoute
                    path="/reports/lista/:id/edit"
                    layout={LayoutPrincipal}
                    component={EditarListaUsuario}
                    isPublicAccess={true}
                    allowAccessGestorSSE={true}
                />

                <PrivateRoute
                    path="/reports/:reportId?"
                    layout={LayoutPrincipal}
                    component={NewReports}
                    isPublicAccess={true}
                    allowAccessGestorSSE={true}
                    inMaintenance={true}
                />

                <PrivateRoute
                    path="/sugestoes"
                    layout={LayoutPrincipal}
                    component={Sugestoes}
                />
                <PrivateRoute
                    path="/gestaoPerfil"
                    layout={LayoutPrincipal}
                    component={GestaoPerfil}
                />
                <PrivateRoute
                    path="/servicos"
                    layout={LayoutPrincipal}
                    component={Servicos}
                />
                <PrivateRoute
                    path="/funcionalidades"
                    layout={LayoutPrincipal}
                    component={Funcionalidades}
                />

                <PrivateRoute
                    path="/tabelas-de-controle/versao/:id/edit"
                    layout={LayoutPrincipal}
                    component={EditarVersaoApp}
                />

                <PrivateRoute
                    path="/tabelas-de-controle/EventoSebrae/:id/edit"
                    layout={LayoutPrincipal}
                    component={EditarEventoSebrae}
                />

                <PrivateRoute
                    path="/tabelas-de-controle/tipoRegistro/:id/edit"
                    layout={LayoutPrincipal}
                    component={EditarTipoRegistro}
                />

                <PrivateRoute
                    path="/tabelas-de-controle/tipoRegistro/:id/copy"
                    layout={LayoutPrincipal}
                    component={CopiarTipoRegistro}
                />

                <PrivateRoute
                    path="/tabelas-de-controle/projetosAcoes/:id/edit"
                    layout={LayoutPrincipal}
                    component={EditarProjetoAcoes}
                />
                <PrivateRoute
                    path="/tabelas-de-controle/canais-digitais/:id/edit"
                    layout={LayoutPrincipal}
                    component={EditarCanaisDigitais}
                    allowAccessGestorSSE={true}
                />

                <PrivateRoute
                    path="/tabelas-de-controle"
                    layout={LayoutPrincipal}
                    component={TabelasDeControle}
                    allowAccessGestorSSE={true}
                />

                <Redirect to="/"/>
            </Switch>
        </BrowserRouter>
    );
}

export default Routes;
